// A dashboard Activity/Reports card with the THEME scrollbar (no custom native
// overflow bar) + an expand arrow that opens a tall modal (keeps a normal width,
// height nearly full-screen) for a big visual read. Used on the production and
// sales dashboards.
import { useState } from 'react';
import { Card, Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpand } from '@fortawesome/free-solid-svg-icons';
import ActivityTimeline from './ActivityTimeline';

const ExpandableActivityCard = ({
  title,
  subtitle,
  reports,
  loading,
  height = 420,
  // Where the whole history lives. The card shows the newest hundred and has no
  // notion of a day; `seeAllTo` is the way from "what just happened" to "what
  // happened on the 12th".
  seeAllTo
}) => {
  const [open, setOpen] = useState(false);
  const timeline = <ActivityTimeline reports={loading ? null : reports} />;

  const seeAll = seeAllTo && (
    <Button as={Link} to={seeAllTo} variant="link" size="sm" className="px-2 py-1">
      See all
    </Button>
  );

  return (
    <>
      <Card className="h-100">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-start">
            <Card.Title className="mb-1">
              <h3 className="text-1100">{title}</h3>
            </Card.Title>
            <div className="d-flex align-items-center gap-1">
              {seeAll}
              <Button
                variant="phoenix-secondary"
                size="sm"
                className="px-2 py-1"
                title="Expand"
                onClick={() => setOpen(true)}
              >
                <FontAwesomeIcon icon={faExpand} />
              </Button>
            </div>
          </div>
          {subtitle && <p className="text-700 mb-4">{subtitle}</p>}

          {/* theme scrollbar (auto-styled) — no inline native overflow bar */}
          <div className="scrollbar" style={{ maxHeight: height, overflowX: 'hidden' }}>
            {timeline}
          </div>
        </Card.Body>
      </Card>

      <Modal show={open} onHide={() => setOpen(false)} size="lg" centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center gap-2">
            {title}
            {seeAll}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="scrollbar" style={{ height: '82vh', overflowX: 'hidden' }}>
          {timeline}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ExpandableActivityCard;
